import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumTextValue } from "@/Models/Validators/MaximumTextValue";
import { MinimumTextValue } from "@/Models/Validators/MinimumTextValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class TextConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'desired_length',
		];
	}

	get_modifier_keys(): string[] {
		return [
			'font',
			'text',
			'desired_dimension',
		];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			width: maximum_rectangle.get_length(),
			height: maximum_rectangle.get_width()
		};
	}

	get_labels(): Record<string, string> {
		const { font, text, desiredDimension } = window.measurementSelectorVariables.i18n.text;
		const { height, width } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			font,
			text,
			height,
			width,
			desired_dimension: desiredDimension,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			text: [ MinimumTextValue, MaximumTextValue ],
			desired_length: [ MaximumDecimalPoints, MinimumValue ],
		};
	}

	get_category(): ShapeCategory {
		return '';
	}
}
